(function () {
  var COMPANY_ID = 'VjxVaQ';
  var LIST_ID = 'TUQzha';
  var API_REVISION = '2024-10-15';

  function getEmailInput(form) {
    var inputs = form.querySelectorAll('input[type="email"], input[name*="email"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value && inputs[i].value.indexOf('@') > 1) return inputs[i].value.trim();
    }
    return null;
  }

  function fireMetaLeadEvent(source) {
    if (typeof fbq === 'function') {
      fbq('track', 'Lead', {
        content_name: 'klaviyo_email_signup',
        content_category: source || 'website'
      });
    }
  }

  function showSuccess(form) {
    var wrapper = form.parentNode;
    var existing = wrapper.querySelector('[class*="success"]');
    if (existing) {
      form.style.display = 'none';
      existing.style.display = 'block';
      return;
    }
    form.style.display = 'none';
    var msg = document.createElement('p');
    msg.style.cssText = 'color:#00d4aa;font-size:16px;font-weight:600;padding:16px 0;text-align:center;';
    msg.textContent = "You're in. We'll keep you posted.";
    wrapper.appendChild(msg);
  }

  function showError(form, message) {
    var wrapper = form.parentNode;
    var existing = wrapper.querySelector('[class*="error"]');
    if (existing) {
      existing.textContent = message || 'Something went wrong. Please try again.';
      existing.style.display = 'block';
      return;
    }
    var msg = document.createElement('p');
    msg.style.cssText = 'color:#ff4444;font-size:14px;padding:8px 0;text-align:center;';
    msg.textContent = message || 'Something went wrong. Please try again.';
    form.appendChild(msg);
  }

  async function submitToKlaviyo(form) {
    var email = getEmailInput(form);
    if (!email) return;

    var source = form.getAttribute('data-klaviyo-source') || 'website';
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('data-original', btn.textContent); btn.textContent = '...'; }

    try {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { clash_source: source }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: LIST_ID } }
          }
        }
      };

      var res = await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': API_REVISION },
          body: JSON.stringify(payload)
        }
      );

      if (res.ok || res.status === 202) {
        fireMetaLeadEvent(source);
        showSuccess(form);
      } else {
        throw new Error('Status ' + res.status);
      }
    } catch (err) {
      if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-original') || 'Subscribe'; }
      showError(form);
    }
  }

  function attachHandler(form) {
    if (form.dataset.klaviyoAttached) return;
    form.dataset.klaviyoAttached = 'true';
    form.removeAttribute('onsubmit');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitToKlaviyo(form);
    });
  }

  function init() {
    document.querySelectorAll('form[data-klaviyo-source]').forEach(attachHandler);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('form[data-klaviyo-source]')) attachHandler(node);
          node.querySelectorAll && node.querySelectorAll('form[data-klaviyo-source]').forEach(attachHandler);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
